import { a as __assign } from '../../../../../tslib.es6-a39f91fc.js';
import { jsx } from 'react/jsx-runtime';
import { Card } from '../../../../cards/card/index.js';
import { IconRenderer } from '../../IconRenderer/IconRenderer.js';
import '../../../../../index-6ea95111.js';
import '../../../../icon/icons/ChevronRight.js';
import 'react';
import '../../../../icon/IconWrapper/IconWrapper.js';
import '../../../../../style-inject.es-1f59c1d0.js';

var CardCell = function (_a) {
    var title = _a.title, description = _a.description, icon = _a.icon, onClick = _a.onClick, href = _a.href, imageComponent = _a.imageComponent;
    var renderedIcon = (jsx(IconRenderer, { icon: icon, imageComponent: imageComponent }));
    return (jsx("div", { className: "ta-left", children: jsx(Card, __assign({ title: title, description: description, density: "balanced", icon: renderedIcon, onClick: onClick }, (href && { href: href, as: 'a' }), { actionIcon: null, showActionIcon: false })) }));
};

export { CardCell };
//# sourceMappingURL=CardCell.js.map
